import { Injectable } from '@angular/core';
import { UrlBuilderService } from '../services/url-builder-service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BuildConfig } from '../model/build-config';

@Injectable({
  providedIn: 'root'
})
export class BuildConfigsService {

  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) {
  }

  public getConfigs(): Observable<BuildConfig[]> {
    return this.http.get<BuildConfig[]>(this.urlBuilder.buildUrl('/build-configs'));
  }

  public getConfig(id: number): Observable<BuildConfig> {
    return this.http.get<BuildConfig>(this.urlBuilder.buildUrl('/build-configs/{id}', {id: id.toString()}));
  }

  public save(config: BuildConfig): Observable<BuildConfig> {
    return this.http.post<BuildConfig>(this.urlBuilder.buildUrl('/build-configs'), config);
  }
}
